import * as React from 'react';
import * as ReactDOM from 'react-dom';

import Firebase, {FirebaseContext, firebaseConfig} from './components/Firebase';

import App from './App';
import './index.css';
import registerServiceWorker from './registerServiceWorker';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import routes from './constants/routes';
import SignInVerification from './containers/SignIn/SignInVerification';
import SignIn from './containers/SignIn/SignIn';


ReactDOM.render(
    <FirebaseContext.Provider value={new Firebase()}>
      <Router>
        <Switch>
          <Route path={routes.SIGN_IN_VERIFICATION} component={SignInVerification} />
          <Route path={routes.SIGN_IN} component={SignIn} />
          <Route path='' component={App} />
        </Switch>
      </Router>
    </FirebaseContext.Provider>,
  document.getElementById('root') as HTMLElement
);
registerServiceWorker();
